<template>
    <div>
        <input
            :name="name"
            type="text"
            :placeholder="placeholder"
            :required="required"
            class="border-gray-300 py-2 h-11 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm w-full"
            :class="[
                hasError ? 'border-red-500 bg-red-100' : '',
                extraClasses,
            ]"
            ref="datepicker"
            :value="modelValue"
            @input="$emit('update:modelValue', $event.target.value)"
        />
    </div>
</template>

<script>
    import { usePage } from '@inertiajs/inertia-vue3'

    import flatpickr from "flatpickr";
    import { FlatpickrDA } from "flatpickr/dist/l10n/da.js"

    const modes = {
        date: {
            enableTime: false,
            dateFormat: 'Y-m-d',
            altFormat: 'd-m-Y',
            noCalendar: false,
        },
        datetime: {
            enableTime: true,
            dateFormat: 'Y-m-d H:i',
            altFormat: 'd-m-Y H:i',
            noCalendar: false,
        },
        time: {
            enableTime: true,
            dateFormat: 'H:i',
            altFormat: 'H:i',
            noCalendar: true,
        },
    };

    export default {
        props: {
            modelValue: {
                type: [String, Number],
                default: '',
            },
            mode: {
                type: String,
                default: 'date',
            },
            name: {
                type: String,
                default: '',
            },
            placeholder: {
                type: String,
                default: '',
            },
            required: {
                type: Boolean,
                default: false,
            },
            hasError: {
                type: Boolean,
                default: false,
            },
            extraClasses: {
                type: String,
                default: null
            },
        },
        emits: ['update:modelValue'],
        mounted() {
            const fp = flatpickr(this.$refs.datepicker, {
                locale: {
                    firstDayOfWeek: 1,
                },
                maxDate: null,
                enableTime: modes[this.mode].enableTime,
                noCalendar: modes[this.mode].noCalendar,
                time_24hr: true,
                dateFormat: modes[this.mode].dateFormat,
                altInput: true,
                altFormat: modes[this.mode].dateFormat,
                static: false,
            });
        },
    }
</script>
